import React from 'react';
import { Tooltip, Icon } from 'antd';
import { Card, Title, Value, Percentage, InfoIcon, CardContainer, CardFront, CardBack, RevenueText } from './styles';

const SummaryCard = ({ item, onClick, showTrend = false, isHighlighted = false, revenue }) => {
  const handleClick = () => {
    if (onClick && item.done > 0) {
      onClick(item);
    }
  };
  
  const formatRevenue = (value) => {
    if (!value || value === 0) return null;
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(value);
  };
  
  const formattedRevenue = formatRevenue(revenue || item.revenue);

  // If no revenue, render the card normally without flip effect
  if (!formattedRevenue) {
    return (
      <Card 
        onClick={handleClick}
        clickable={item.done > 0}
        isHighlighted={isHighlighted}
        style={{ cursor: item.done > 0 ? 'pointer' : 'default' }}
      >
        <Tooltip title={item.tooltip} placement="bottom">
          <InfoIcon>
            <Icon type="info-circle" />
          </InfoIcon>
        </Tooltip>
        <Percentage>{item.percentage}</Percentage>
        <Title color={item.color}>
          {item.title}
          {item.icon}
        </Title>
        <Value isHighlighted={isHighlighted}>{item.done}</Value>
        
        {/* Show trend indicators for funnel metrics */}
        {showTrend && (item.trendIcon || item.trendText) && (
          <div style={{ 
            fontSize: '10px', 
            fontWeight: '600',
            marginTop: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}>
            {item.trendText && (
              <span style={{ color: (item.trendIcon && item.trendIcon.props && item.trendIcon.props.style && item.trendIcon.props.style.color) || '#6c757d' }}>
                {item.trendText}
              </span>
            )}
            {item.trendIcon}
          </div>
        )}

        {/* Show pricing for legacy cards */}
        {item.pricing && (
          <div style={{ 
            fontSize: '10px', 
            color: item.columnId === 3 ? '#28a745' : item.columnId === 4 ? '#dc3545' : '#8c8c8c', // Green for Positivo, red for Negativo, gray for others
            fontWeight: '600',
            marginTop: '2px' 
          }}>
            {item.pricing}
          </div>
        )}
      </Card>
    );
  }
  
  // Render with flip effect for cards with revenue
  return (
    <CardContainer
      onClick={handleClick}
      clickable={item.done > 0}
      hasRevenue={!!formattedRevenue}
    >
      <CardFront isHighlighted={isHighlighted}>
        <Tooltip title={item.tooltip} placement="bottom">
          <InfoIcon>
            <Icon type="info-circle" />
          </InfoIcon>
        </Tooltip>
        <Percentage>{item.percentage}</Percentage>
        <Title color={item.color}>
          {item.title}
          {item.icon}
        </Title>
        <Value isHighlighted={isHighlighted}>{item.done}</Value>
        
        {/* Show trend indicators for funnel metrics */}
        {showTrend && (item.trendIcon || item.trendText) && (
          <div style={{ 
            fontSize: '10px', 
            fontWeight: '600',
            marginTop: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}>
            {item.trendText && (
              <span style={{ color: (item.trendIcon && item.trendIcon.props && item.trendIcon.props.style && item.trendIcon.props.style.color) || '#6c757d' }}>
                {item.trendText}
              </span>
            )}
            {item.trendIcon}
          </div>
        )}
      </CardFront>
      
      <CardBack color={item.color}>
        <Title color="white">
          Receita
        </Title>
        <RevenueText>{formattedRevenue}</RevenueText>
      </CardBack>
    </CardContainer>
  );
};

export default React.memo(SummaryCard); 